const en = {
  flow: {
    keyFigure: {
      title: 'KEY FIGURES',
      dwellTime: 'Dwell time',
      footfall: 'Footfall',
    },
  },
  keepeekPicture: {
    noMedia: 'No Media',
  },
  comparable: {
    r12m: 'Comparables (footfall R12M)',
  },
  navigator: {
    outdated: 'Gemini might not work on your current browser, please consider using Google Chrome for a better experience.',
  },
  example: {
    modalContent: 'Je suis une modale',
  },
  confidential: 'Strictly confidential and for internal use only',
  sentry: {
    TITLE: 'Oops...',
    SUBTITLE: 'Something went wrong',
    LINK_DESCRIPTION: 'Please retry later and refresh your page, you can also report a bug ',
    LINK_ACTION: 'here',
  },
  wsError: {
    NO_DATA: 'Missing data: %{field0}',
    INTERNAL_ERROR: 'Internal error',
    BROWSER_NOT_SUPPORTED: 'This browser is not supported. Use another browser to navigate on this website.',
    OFFICE_ID_NOT_FOUND: 'Office %{field0} not found',
    SHOPPING_CENTER_ID_NOT_FOUND: 'Shopping center %{field0} not found',
  },
  option: {
    ALL: 'ALL',
  },
  days: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  },
  months: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  country: {
    AT: 'Austria',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DK: 'Denmark',
    ES: 'Spain',
    FR: 'France',
    GB: 'United Kingdom',
    IT: 'Italy',
    NL: 'Netherlands',
    PL: 'Poland',
    SE: 'Sweden',
    SK: 'Slovakia',
    US: 'USA',
    HU: 'Hungary',
    GE: 'Georgia',
    FI: 'Finland',
  },
  tooltip: {
    source: 'Source :',
    softComputing: 'Soft computing',
    mercury: 'Mercury',
    definition: 'Definition :',
    omUpdated: 'updated by OM',
    storeNumber: 'Total number of store of the SC',
    glaNumber: 'Total GLA of the SC',
    linkNumber: 'Automatically linked to data from Mercury',
    salesR12M: 'Lastest sales R12M data from Mercury',
    r12m: 'R12M of the current month (i.e. April 2022 to March 2023)',
    r12mannual: 'R12M from last year (i.e. January 2022 to December 2022)',
    parkingSpace: 'Total number of parking spaces of the SC',
    screenNumber: 'Number of cinema screens',
    linkGla: 'Automatically linked to GLA from Mercury',
    glaHyperMarket: 'GLA of the Hyper market',
    sourceLoyalty: 'Automatically retrieved from Digital source',
    defLoyalty: 'Number of loyalty cart holders',
    international: 'International',
    locomotive: 'Locomotive',
    data_overridden: 'Data overridden manually',
    dwell_time_source: 'MyFeelBack Full year 2019',
    dwell_time_content: 'Average time spent in minutes by loyal visitors on the shopping center during their visit.',
    isochrone_source: 'CACI %{year}',
    isochrone_content: 'Visitors taking %{range} to come to the shopping center',
    average_spend_basket_source: 'Transactional Loyalty Program 2019',
    average_spend_basket_content: 'Average amount spent in your shopping centre.',
    bp: 'BP',
  },
  header: {
    subject: 'Turan-web feedback for shopping centre %{scName}',
    body: 'Hello%2C%0D%0APlease find  my below remarks concerning the application:%0D%0A%0D%0ABest regards',
    Move_up: 'Move up',
    MALL: 'MALL',
    AREA: 'AREA',
    STORE: 'STORE',
    Area: 'Area',
    Mall: 'Mall',
    OFFICE: 'OFFICE',
    Store: 'Store',
    MAP: 'MAP',
    HOME: 'HOME',
    // Code ascii d'un cadenas
    PERF: '\uD83D\uDD12 PERF',
    SHOPPING_CENTERS: 'ASSETS',
    INFO: 'INFO',
    FLOW: 'FLOW',
    SHOPPERS: 'SHOPPERS',
    MEDIA: 'MEDIA',
    GEMINI: 'GEMINI',
    EVENTS: 'EVENTS',
    lastFiveYears: 'from last five years',
    GROUP_OVERVIEW: 'GROUP',
    INVESTORS: 'INVESTORS',
    MARKETING: 'MARKETING',
  },
  BUSINESS_PLAN_TIMELINE: {
    NOW: 'Now',
    UNSELECT: 'Unselect',
    NO_DATA: 'No Business Plan data found for this centre',
  },
  filters: {
    selected: 'selected',
    CLEAR_FILTER: 'CLEAR FILTER',
    CLEAR_ALL_FILTER: 'CLEAR ALL FILTER',
    FILTER: 'FILTER',
    STORE: 'STORE',
    CENTER_GLA: 'CENTER GLA',
    VISITORS: 'VISITORS',
    ASSET_FEATURES: 'ASSET FEATURES',
    Shopping_centers: 'Shopping centers',
    CITIES: 'CITIES',
    offices: 'Offices',
    findByStoreName: 'Find by store name',
  },
  worldData: {
    GROUP_OVERVIEW: {
      PROFILE: 'PROFILE',
      CORPORATE_GOVERNANCE: 'CORPORATE GOVERNANCE',
      BUSINESS_DIVISION: 'BUSINESS DIVISION',
      PIPELINE_PROJECT: 'PIPELINE PROJECT',
      DESTINATION: 'DESTINATION',
      INNOVATIONS: 'INNOVATIONS',
      PRESENTATION: 'PRESENTATION',
    },
    FINANCE_INVESTOR: {
      HOME: 'HOME',
      SHARE_PERFORMANCE: 'SHARE PERFORMANCE',
      FINANCIAL_RESULTS: 'FINANCIAL RESULTS',
      CONTACTS: 'CONTACTS',
    },
    MARKETING: {
      EVENTS_LABEL: 'MARKETING CAMPAIGNS',
      BRAND_EXPERIENCE: 'BRAND EXPERIENCE',
      MALL_RETAILER: 'MALL RETAILER',
      MEDIA: 'MEDIA',
      ADVERTISING: 'ADVERTISING',
      DIGITAL: 'DIGITAL',
    },
  },
  mallData: {
    INTRO_LABEL: 'INTRO',
    FACT_FIGURE_LABEL: 'FACT & FIGURES',
    STORE_LABEL: 'STORES',
    MARKETING_LABEL: 'MARKETING',
    PRACTICAL_INFO_LABEL: 'PRACTICAL INFO',
    NO_DATA: 'There are not sufficient data available to show the page %{page} for this mall',
    NO_DATA_EVENTS: 'The marketing manager didn’t filled the necessary informations to show the page %{page} for this mall',
    STORE: {
      ANCHOR: 'Anchor (%{anchorNumber})',
      BRANCH_LEVEL: 'Branch level :',
      GLA: 'Gross Leasable Area (m²) :',
      OPENING_DATE: 'Opening Date :',
      SECTOR_SALES: 'Sector sales *',
      SECTOR_SPREAD: 'Sector spread **',
      SECTOR_SALES_LEGEND: '* Average sector sales for small unit: rented shopping center GLA sales/m2: excl LU, MSU, atypical, activity',
      SECTOR_SPREAD_LEGEND: '** GLA spread per sector: BL1 GLA',
    },
    INTRO: {
      ACCESS_PLAN: 'ACCESS PLAN',
    },
    FACT_FIGURE: {
      titles: {
        general: 'General',
        assets: 'Assets',
        isochronousZones: 'Isochronous zones',
      },
      STORE: 'Stores',
      GLA: 'GLA',
      VISITS: 'Visits',
      YEARLY_VISITS: 'Annual visits',
      PARKING_SPACE: 'Parking Spaces',
      SCREENS: 'Screens',
      BRANCH_LEVELS: 'Branch levels',
      STORES: 'Stores',
      TOTAL_SALES: 'Total Sales',
      AVERAGE_SPEND_BASKET: 'Average spend basket',
      DWELL_TIME: 'Dwell time',
      ISO_ZONE_TITLE: 'ISO %{iso}',
      ISO_ZONE_INHABITANTS: '%{totalPopulation} inhabitants',
      ISO_ZONES: {
        '10-': {
          title: '0-10',
          range: 'under 10 minutes',
        },
        20: {
          title: '10-20',
          range: 'between 10 and 20 minutes',
        },
        30: {
          title: '20-30',
          range: 'between 20 and 30 minutes',
        },
        40: {
          title: '30-40',
          range: 'between 30 and 40 minutes',
        },
        50: {
          title: '40-50',
          range: 'between 40 and 50 minutes',
        },
        60: {
          title: '50-60',
          range: 'between 50 and 60 minutes',
        },
        '60+': {
          title: '60+',
          range: 'more than 1 hour',
        },
      },
    },
    PRACTICAL_INFO: {
      MOBILE: 'Mobile: %{mobile}',
      EMAIL: 'Email: %{email}',
      TO: '%{from} to %{to}',
      OPENING_HOURS: 'Opening hours',
      SPECIAL_OPENING: 'Special opening',
    },
    MARKETING: {
      CATCHMENT_AREA: {
        LABEL: 'Catchment area & Customer profile',
        ZIP_CODE: 'Zip Code',
        ZONES: 'Zones',
        RANGE: 'Range',
        FILTERS: 'Filters',
        WAITING_MESSAGE: 'Catchment area map is loading ...',
        FAKE_WAITING_MESSAGE: 'Catchment area picture is loading ...',
        KPIS: 'Key Performance Indicator',
        LEGEND_TITLE: 'Legend',
        PENRATE_TITLE: 'Penetration Rate Catchment Area',
        VISITORS_TITLE: 'Visitors Catchment Area',
        SOCIO_TITLE: 'Socio Demo Catchment Area',
        COMPETITOR: 'Competitor: ',
        DATE: 'Date: ',
        KPI: {
          PENRATE: 'Penetration Rate',
          VISITORS: 'Visitors',
          UVSHARE: 'Unique Visitors Share',
          POPEVOL: 'Population Evolution',
          MEDIANINCOME: 'Median Income',
          INDEX100INCOME: 'Index 100 Income',
          MIDDLEAGE: 'Middle Age',
          TOTALCSP: 'Total CSP',
          DENSITYKM2: 'Density By Km²',
        },
      },
      LOYALTY_CARD: 'Loyalty Cards',
      WEBSITE_VISITOR: 'Website visitors',
      AVG_HOUSEHOLD_INCOME: 'Average household income',
      POPULATION_GROWTH: 'Population Growth',
      PRIMARY: 'Primary',
      SECONDARY: 'Secondary',
      TERTIARY: 'Tertiary',
      TOTAL: 'Total',
      PENETRATION_RATE: 'Penetration rate',
      NUMBER_INHABITANT: 'Number of inhabitants',
      MALE: 'Male',
      FEMALE: 'Female',
      BY_CAR: 'By car',
      BY_PUBLIC: 'By public transport',
      BY_BICYCLE: 'By bicycle',
      AVERAGE_SPENDING: 'Average spending',
      AVERGAE_VISIT_TIME: 'Average visit time',
    },
    MEDIA: {
      SELECTBUILDING: 'Please select a building',
      LAYOUT: 'LAYOUT',
      PICTURES: 'PICTURES',
      BROCHURES: 'BROCHURES',
      VIDEO: 'VIDEO',
      BROCHURE_PLAN: 'Scheme',
      VIRTUAL_VISITS: 'VIRTUAL VISITS',
      REDIRECT: 'Go to the website',
      EMPTY_GALLERY: 'This gallery is empty',
      NO_MEDIA: 'No media to display',
    },
    EVENTS: {
      NO_EVENTS: 'There is no event for this Mall',
      OPENING: ' OPENING',
    },
  },
  mallMap: {
    GEMINI_USER: 'You are a Gemini user but you don\'t have the permission to acces this shopping center.',
    LEVEL: 'Level',
    NO_MAP: 'There is no map for this Mall',
    REDIRECT: 'Go to leasing plan',
    ID_VISIOGLOBE: 'Code Store',
    RETAILER: 'Retailer',
    GO_TO_STORE: 'Launch Simulation',
  },
  group_overview: {
    PROFILE: {
      TITLE: 'The premier global developer and operator of flagship shopping destinations',
      INTRO: 'Unibail-Rodamco-Westfield specialises in owning, developing and managing premier retail assets (shopping centres and airports) in the most dynamic cities in Europe and the United States, the most prestigious office buildings and major convention & exhibition venues in the Paris region.',
      GRID_ITEMS: {
        PORTFOLIO: 'Portfolio valuation*',
        COUNTRIES: 'countries',
        EMPLOYEES: 'employees',
      },
      ACTIVITIES: {
        TITLE: '3 activities of the commercial real estate industry',
        DEVELOPER: 'Developer',
        OPERATOR: 'Operator',
        INVESTOR: 'Investor',
      },
      KEY_DATES: 'Key dates',
    },
    CORPORATE_GOVERNANCE: {
      TITLE: 'The Group\'s governance is made up of four bodies',
      INTRO: 'The Management Board and the Supervisory Board, which form the two-tier board structure of the Company, as well as the Advisory Board.',
      BACK: 'Back',
      SEE_MEMBERS: 'See Members',
      ETHICS: 'Code of ethics',
      MANAGEMENT_BOARD: {
        TITLE: 'Management Board',
      },
      SUPERVISORY_BOARD: {
        TITLE: 'Supervisory Board',
      },
      SUSTAINABLE_BOARD: {
        TITLE: 'Sustainable and ethical conduct',
      },
      MEMBERS: {
        CUVILLIER: 'Group CEO',
        DYER: 'Chairman',
      },
      AWARDS: {
        TITLE: 'Awards',
      },
    },
    BUSINESS_DIVISION: {
      LINKS: {
        MAIL: 'EMail',
        WEBSITE: 'WebSite',
        APPSTORE: 'AppStore',
      },
      KEY_ASSETS: 'Key assets',
      BACK: ' Back',
      MAIN_TENANTS: 'Main tenants: ',
      SHOPPING_CENTER: {
        TITLE: 'Shopping Centers',
        GLA: 'GLA*',
        GLA_SUB: 'in continental Europe',
        KEY_FIGURE: {
          TITLE: 'Key figures',
          SC: 'Shopping centers*',
          PORTFOLIO: 'Portfolio*',
          VISITS: 'Visits per year*',
        },
        FOCUS: {
          TITLE: 'Focus on large regional shopping centers',
          ANNUM: 'Visits per annum',
          GLA: 'GLA',
          CATCHMENT_AREA: 'Inhabitants catchment area',
        },
        KEY_ASSETS: {
          YEARS: 'Year of acquisition: %{year}',
          ARCHITECT: 'Architect: %{architect}',
          GLA: 'GLA',
          VISITS: 'Visits',
          CATCHMENT_AREA: 'Catchment area inhab.',
          SHOPS: 'Shops',
          CINEMA: 'Cinema screens',
        },
      },
      OFFICES: {
        TITLE: 'Offices',
        GLA: 'GLA*',
        FRENCH_OFFICE: 'French office portfolio*',
        FOCUS: {
          TITLE: 'Focus on prime assets in the best locations in Paris CBD and La Défense',
          MARKET_VALUE: 'Of the group\'s gross market value',
          ASSETS: 'Standing assets in France*',
        },
        KEY_ASSETS: {
          ACQUIRED: 'Acquired',
          GLA: 'GLA',
          BUILT: 'Built',
        },
      },
      CONVENTIONS: {
        TITLE: 'Conventions & Exhibitions',
        KEY_FIGURE: {
          TITLE: 'Key figures',
          VENUES: 'Venues',
          CONVENTION: 'Convention & Exhibition portfolio',
        },
        FOCUS: {
          TITLE: 'Leader on the Paris Market',
          EVENTS: 'Events in 2017',
          SHOWS: 'Shows in 2017',
        },
      },
      PIPELINE_PROJECTS: {
        TITLE: 'Pipeline Projects',
        KEY_FIGURE: {
          TITLE: 'Key figures',
          PRIME: 'Prime quality development pipeline',
          PIPELINE: 'of pipeline projects',
        },
        FOCUS: {
          NEW: 'New shopping centres',
          EXTENSIONS: 'Extensions & renovations of shopping centres',
          OFFICES: 'Offices & residentials',
        },
      },
    },
    DESTINATIONS: {},
    INNOVATIONS: {},
    PRESENTATIONS: {},
  },
  FINANCE_INVESTOR: {
    TITLE: 'Unibail-Rodamco-Westfield: A unique player',
    HOME: {
      quote: 'Quote',
      consensus: 'Consensus',
      seeAnalysts: 'See Analysts',
      agenda: 'Agenda',
      analysts: {
        title: 'Consensus Note - Analytics',
        company: 'Company',
        analyst: 'Analyst',
      },
    },
    SHARE_PERFORMANCE: 'SHARE PERFORMANCE',
    FINANCIAL_RESULTS: 'FINANCIAL RESULTS',
    CONTACTS: 'CONTACTS',
    ALT_BACKGROUND: 'Business division background',
  },
  GROUP_OVERVIEW: {
    DESTINATION: {
      shoppingCenters: 'Shopping Centers',
      medias: 'Medias',
    },
  },
  OFFICE: {
    INTRO: 'Intro',
    FACT_FIGURE: 'Facts & Figures',
    KEY_FIGURE: 'Key Figures',
    KEY_FACTS: 'Key Facts',
    SERVICE: 'Services',
    NO_SERVICE: 'No service',
    CONTACT: 'Contacts',
    OFFICEDESCRIPTION: 'Office Description',
    BUILDINGDESCRIPTION: 'Building Description',
    NO_TENANT: 'No tenant',
    BUILDINGS: 'Buildings',
    TENANTS: 'List of tenants',
    TECHNICALDESCRIPTION: 'Technical Description',
    SUSTAINABLEDEVELOPMENT: 'Sustainable Development',
    COMPANIES: 'Companies',
    TABLE: {
      AVAILABLE: 'Available',
      RENTED: 'Rented',
      LEVEL: 'Level',
      GLA: 'GLA',
      AVERAGE: '(average: %{averageGLA}m²)',
      COMMENTS: 'Comments',
      DISPONIBILITY: 'Disponibility',
    },
    FLOORS: 'Floors',
    NO_FLOOR: 'No floor',
    WEBSITE: 'Website',
    EMAIL: 'Email',
    LOCATIONS_CONTACTS: 'Locations & Contacts',
    ACCESS_OPTIONS_ROUTES: 'Access options/routes',
    BUILDINGS_KEY_FACTS: {
      SURFACE: 'Surface area',
      HEIGHT: 'Height',
      PARKING: 'Parking spaces',
      NUMBER_FLOOR: 'Number of floors',
      ARCHITECT: 'Architect',
      WORKSTATIONS: 'Workstations',
    },
  },
  SIDE_MENU: {
    report: 'Available Reports',
    report_unauthorized: 'You don\'t have the necessary Mercury rights to download this report',
    unit_size: 'UNIT SIZE',
    point_of_view: 'POINT OF VIEW',
    currency: 'CURRENCY',
    CURRENCY_LOWER: 'Currency',
    CONVERSION_RATE: 'Converstion rate',
    CONVERSION_FACTOR: '1€ = %{factor} %{symbol}',
    CONVERSION_FACTOR_EN: '1€ = %{symbol} %{factor}',
    EUR: 'Euro',
    USD: 'US Dollar',
    GBP: 'GB Pound',
    AED: 'AE Dirham',
    HKD: 'HK Dollar',
    DKK: 'DK Krone',
    RUB: 'RU Ruble',
    BRL: 'BR Real',
    CAD: 'CA Dollar',
    SGD: 'SG Dollar',
    AUD: 'AU Dollar',
    CNY: 'Yuan',
    CZK: 'CZ Koruna',
    PLN: 'Zloty',
    PHP: 'PH Peso',
    SEK: 'SW Krona',
    dimension: 'Dimension',
    m: 'Metric',
    ft: 'Imperial',
    m5_report: 'M5.1',
    m5_report_filename: 'M5.1_%{scName}.xlsx',
    goodwill_report: 'Goodwill',
    goodwill_report_filename: '%{shoppingCenter}_%{retailerName}_Goodwill.xlsx',
    leasing_plans: 'Leasing plans',
  },
  GEMINI_HEADER: {
    all: 'ALL',
    su: 'SU',
    lu: 'LU',
    msu: 'MSU',
    shoppingCenter: 'SC',
    branch: 'Branch',
    zone: 'Zone',
    shop: 'Shop',
  },
  COMPARABLE: {
    showFilters: 'Show parameters',
    hideFilters: 'Hide parameters',
    filtersTitle: 'Parameters',
    sameCountry: 'Same country',
    sameCategory: 'Same category',
    all: 'All',
    average: 'Average',
    typesOfComparable: 'Types of comparables',
    countries: 'Countries',
    addCustomStore: 'Add a custom store from this shopping center',
    findStore: 'Find Store',
    findSc: 'Find SC',
    removeCustomStore: 'Remove this custom store',
    chooseCustomSc: 'Custom shopping center',
  },
  SIDE_DATA: {
    description: 'Description',
    analysis: 'Analysis',
    apollo: 'Best substitution',
    notAvailable: 'This functionality is not available for this country',
    mappingConflict: 'Mapping conflict',
    COMPARABLE: 'Benchmark',
    no_data: 'No comparable data available',
    CHART: 'Chart',
    isEx: 'Ex - ',
    OLD_TENANT: '(Old Tenant)',
    rental_space: 'Rental Space (%{idVisioglobes})',
    m2_report: 'Raw data (M2.2)',
    m2_report_filename: 'M2.2_%{retailerId}.xlsx',
    UNMAP_STORE: 'Unmap store',
    COMPUTE_STORE_DISTANCES: 'COMPUTE STORE DISTANCES',
    WHITE_BOARD: {
      branchLevel: 'Branch level',
      reversionaryDate: 'Reversionary date',
      openingDate: 'Opening date',
      configurationWeighting: 'Configuration Weighting',
      zone: 'Zone',
      glaSplit: 'GLA split',
      nbSignf: 'Nb significant',
      locationWeighting: 'Location weighting',
      closingDate: 'Closing date',
      nextBreakOption: 'Next break option',
      idRetailer: 'Id retailer',
      codstr: 'Id store (codstr)',
      idsVisioglobe: 'Visioglobe Ids',
    },
    EMPTY_UNIT: {
      title: 'Empty unit (%{idVisioglobes})',
      subtitle: 'Empty unit',
      MUST_BE_MAPPED: 'This store must be mapped before finding a best retailer',
      MUST_BE_MAPPED_WITH_MAPPING_MODE: 'This store is not mapped yet. You can map it in the mapping mode.',
      CHOOSE: 'Choose among these stores :',
      NO_STORES: 'No stores available for mapping',
      STORES_RED: 'Closed stores appears red',
    },
    BUSINESS_PLAN: {
      oldMgr: 'Old MGR',
      mgrUplift: 'MGR uplift',
      effectiveRentUplift: 'Effective Rent Uplift',
      rentFreePeriod: 'Rent free period',
      oldTenant: 'Old tenant',
      tenant: 'Tenant',
      signatureDate: 'Signature date',
      effectiveDate: 'Effective date',
      endDate: 'End date',
      mgr: 'MGR',
      effectiveRent: 'Effective rent',
      rentIncentives: 'Rent incentives',
      keyMoney: 'Key money',
      stepRent: 'Step rent %{number}',
      foc: 'FOC',
      erv: 'ERV',
      trv: 'TRV',
      rrv: 'RRV',
      operationId: 'Operation ID (PlanIT)',
      oldContract: 'Old Contract',
      newContract: 'New Contract',
    },
  },
  comparator: {
    phrase: {
      default: 'Click on "Add Filter" to add a new one',
      searchingAmong: 'Searching among',
      internationalRetailers: ' international retailers',
      allRetailers: ' all retailers',
      inComparableSC: ' in comparable shopping centers',
      equivalentGla: ' with equivalent GLA size (+/- 25%)',
      withThe: ' with the ',
      inTheSelectedBls: ' in the selected BLs',
      with: ' with ',
      located: ' located ',
      scCategory: 'SC Category %{category}',
      mustBeWestField: 'SC must be a WestField',
      mustBeFlagship: 'SC must be a Flagship',
      inTheSelectedCountries: 'in the selected countries (%{countries})',
      inTheCurrentCountry: 'in the current country (%{country})',
      locationType: {
        inside: 'inside the shopping center',
        outside: 'outside the shopping center',
        pool_sc: 'in a pool of shopping center selected in the filters',
        pool_country: 'in a pool of country selected in the filters',
        unconcerned: '',
      },
      findBl: 'Find BL',
      findCountry: 'Find Country',
      findSc: 'Find SC',
      findCategory: 'Find Category',
    },
    su: 'SU',
    msu: 'MSU',
    lu: 'LU',
    simulation: 'Simulation',
    generateM30: 'Generate Commercial Operation',
    m30Loading: 'Generation is running, it might takes few seconds',
    addFilters: ' Add Filters',
    search: 'Search',
    branchLevel: 'Branch level :',
    sameBranchLevel1: 'Same BL 1 %{bl1}',
    sameBranchLevel2: 'Same BL 2 %{bl2}',
    sameBranchLevel3: 'Same BL 3 %{bl3}',
    allBl: 'any BL',
    otherbl: 'Other BL %{bl2}',
    unconcerned: 'All',
    localisation: 'Location :',
    insideTheCenter: 'In the SC',
    otherLocation: 'Shopping centres %{scCount}',
    poolCountries: 'Countries %{scCount}',
    outsideTheCenter: 'Not in the SC',
    typeOfRetailers: 'Type of retailers',
    locationType: 'Location Type',
    internationalRetailers: 'Including international retailer',
    equivalentGla: 'With equivalent GLA size (+/- 25%)',
    inComparableSC: 'In comparable shopping center',
    headerPhrase: 'Find the best* retailers for the current unit',
    headerInfo: '*List of retailers, upon criterias, ordered by kpi maximization\'s',
    moreRetailers: 'more retailers',
    howWasThisDataComputed: 'How was this data computed ?',
    clicThe: 'Clic the',
    iconKPI: ' next to the KPI to get the formula',
    performanceSimulator: 'Performance Simulator',
    RESET_GRAPH: 'RESET GRAPH',
    salesR12M: 'Sales R12M',
    glaTot: 'Gross Leasable Area Total (Including SST)',
    catchmentArea: 'Catchment Area',
    numbersOfRetailersInADistanceLimit: 'Number of retailers in a %{km} km radius: ',
    numbersOfRetailersBetweenTwoDistance: 'Number of retailers between %{minimumKm} and %{maximumKm} km: ',
    numbersOfRetailersInATimeLimit: 'Number of retailers in less than %{minute} minutes: ',
    numbersOfRetailersBetweenTwoTime: 'Number of retailers between %{minimumMinute} and %{maximumMinute} minutes: ',
    numberOfRetailersNearby: 'Number of retailers nearby: ',
    nearestRetailer: 'Nearest retailer : ',
    noRetailerFound: 'No retailer found',
    year: 'Year',
    month: 'Month',
    customRetailer: 'Add Custom Retailers ',
    country: 'Add Country : ',
    YEAR_MONTH: 'Update time',
    INFO1: 'This simulator allows you to compare the selected Branch Levels performance of the current shopping centre versus the other shopping centres that have been selected in the filters (%{shoppingCenters}).\n',
    INFO2: 'You can add and delete branches on you graph by clicking them in the legend container at the bottom of this graph.\n',
    KPI: {
      GLA: 'GLA / SST',
      BL2: 'BL2',
      OCR: 'OCR',
      ERV: 'RRV / TRV :',
      SALES: 'Sales',
      MGR: 'MGR',
      SBR: 'SBR',
      SCH: 'SCH',
      FRA: 'Rent free period',
      PAL: 'Step rents',
      TARGET_OCR: 'Target OCR',
      COVERAGE_TYPE: 'Retailer type',
      INTERNATIONAL: 'International',
      NATIONAL: 'National',
      OOC: 'Other Loyer and OC',
      INCENTIVES: 'Incentives',
      BL_SHARE: 'BL2 Share',
      BL_REPRESENTATION: 'BL2 Representation',
      SURROUNDING: 'Web Affinity',
      SCH_RETAILER: 'Rents incentives',
      RENT_FREE_PERIOD: 'Rent free period',
      PREDICTED_OCR: 'Predicted OCR',
    },
    details: 'Details',
    rawData: 'Raw Data',
    commercialOperation: 'Raw Data (Commercial operation model)',
    noStoreData: 'No data for this store',
    noPropositions: 'No propositions',
  },
  GEMINI: {
    SELECTED: 'Selected',
    VACANT_UNIT: 'Vacant unit',
    NOT_MAPPED: 'Not mapped',
    MAPPING_CONFLICT: 'Mapping conflict',
    NO_DATA: 'No data',
    NO_RESULTS: 'No results',
    SALES_ESTIMATED: 'Sales estimated',
    OCR: 'OCR',
    SALES: 'Sales',
    SALES_WITHOUT: 'Sales R12M without SST',
    GLA: 'GLA',
    GLA_WITHOUT: 'GLA without SST',
    ERV: 'ERV',
    MGR: 'MGR excl. VAT (R12M)',
    REV_POT: 'Reversionary potential',
    SBR: 'SBR excl. VAT (R12M)',
    OCC_COST: 'Occupancy cost  excl. VAT (R12M)',
    OCR_SUBTITLE: '--',
    SALES_SUBTITLE: 'SALES R12M',
    SALES_ESTIMATED_SUBTITLE: 'SALES R12M_S',
    SALES_WITHOUT_SUBTITLE: 'SALES R12M WITHOUT SST',
    GLA_SUBTITLE: 'GLA WITH SST',
    GLA_WITHOUT_SUBTITLE: '--',
    ERV_SUBTITLE: '--',
    MGR_SUBTITLE: 'MGR SPOT',
    REV_POT_SUBTITLE: 'REV_POT',
    SBR_SUBTITLE: 'SBR INV',
    OCC_COST_SUBTITLE: 'Sum of: INV MGR, SCH, RET, ...',
    NB_KPI_SELECTED: '%{number} KPI used for this sum',
    SELECT_FILTERS: 'Select filters',
    SELECT_ALL: 'Select all',
    UNSELECT_ALL: 'Unselect all',
    THIS_MONTH: 'This month',
    LAST_YEAR: 'Last year',
    PROXY_SALES: 'Proxy sales',
    ALL_SALES: 'All sales',
    BL: 'BL :',
    SAME_BL: 'Same',
    ALL_BL: 'All',
    EMPTY_UNITS: 'Empty Units',
    MAPPING_MODE: 'Mapping',
    SHOW_EMPTY_UNITS: 'Show empty units',
    HIDE_EMPTY_UNITS: 'Hide empty units',
    KPI_FILTER: 'Kpi filter',
    GRAPH: {
      ITSELF: 'Itself',
      SAME_SC: 'Same SC',
      SAME_BL1_undefined: 'Same BL1',
      SAME_BL2_undefined: 'Same BL2',
      SAME_BL1: '%{blname} (BL1)',
      SAME_BL2: '%{blname} (BL2)',
      SAME_BL3: 'Same BL',
      AVERAGE: 'Average',
      AVERAGE_COMPARABLES: 'Average of comparables this month',
      HISTORY: 'History',
      AGGREGATE: 'Aggregate',
      CHART: 'Chart',
      PROXY_STORES: 'Stores at proximity',
    },
    KPI: {
      erv: 'Estimated Rental Value',
      glaDen: '',
      glaWithSst: 'Including separated storage',
      glaWithoutSst: 'Excluding separated storage',
      invAbt: 'Discount',
      invAdm: 'Administration fees',
      invAnn: 'Annuity',
      invCtr: 'Contr. non-rec VAT',
      invFra: 'Rent free',
      invLsw: 'Large scale work',
      invMco: 'Marketing cost',
      invMgr: 'Minimum guaranteed rent',
      invMwo: 'Maintenance work',
      invOin: 'Other income',
      invPal: 'Step rents',
      invPli: 'Parking',
      invRet: 'Real estate taxes',
      invRie: 'Loyer RIE',
      invSbr: 'Sales based rents',
      invSch: 'Service charges',
      ocr: 'OCR',
      ocrDen: '',
      ocrNum: '',
      revPot: 'Reversionary potential',
      rrv: 'Renewal rental value',
      salesM: 'Monthly',
      salesNum: '',
      salesR12m: 'R12M with SST',
      salesR12mWithoutSst: 'R12M without SST',
      salesYtd: 'Year to date',
      spotAbt: 'Discount',
      spotAdm: 'Administration fees',
      spotAnn: 'Annuity',
      spotCtr: 'Contr. non-rec VAT',
      spotFra: 'Rent free',
      spotLsw: 'Large scale work',
      spotMco: 'Marketing cost',
      spotMgr: 'Minimum guaranteed rent',
      spotMwo: 'Maintenance work',
      spotOin: 'Other income',
      spotPal: 'Step rents',
      spotPli: 'Parking',
      spotRet: 'Real estate taxes',
      spotRie: 'Loyer RIE',
      spotSbr: 'Sales based rents',
      spotSch: 'Service charges',
      trv: 'Target reletting value',
    },
    UNIT_SIZE: {
      kpi: 'All',
      su: 'SU',
      msu: 'MSU',
      lu: 'LU',
    },
    POV: {
      shoppingCenter: 'SC',
      branch: 'Branch',
      zone: 'Zone',
      shop: 'Shop',
    },
    METRICS: {
      false: '€',
      true: '€/m²',
    },
  },
  date: {
    long: 'DD/MM/YYYY',
    long_revert: 'YYYY/MM/DD',
  },
  MAPPING_MODE: {
    informationText: {
      EMPTY_UNIT: 'Please set up a store in the CMS associated to visioglobe ID',
      LUX_ONLY: 'No Mercury store match with CMS (Lux) retailer. Please check that retailer is the good one in the CMS, and that the store associated to this retailer exists in Mercury.',
      MULTIPLE_LUX: 'Another store has been found in CMS (Lux) for the same retailer id in mercury',
      MULTIPLE_MERCURY: ' Several store exists for this retailer. Please select the proper Mercury store',
      RETAILER_MISSING: 'No external retailer specified in the CMS. Please fill in the correct retailer in the CMS.',
    },
    CLOSING: 'Closing',
    EMPTY_UNIT: 'No store in CMS (Lux)',
    LUX_ONLY: 'No store in Mercury',
    LUX_ONLY_CURRENT_ID: 'Retailer ID mapped in CMS (Lux): %{retailerId}',
    LUX_ONLY_CURRENT_NAME: 'CMS (Lux) Name: %{luxName}',
    LUX_ONLY_STORE_CMS: 'CMS (Lux) store id : %{idStoreCms}',
    LUX_ONLY_VISIOGLOBE_ID: 'Visioglobe id : %{idVisioglobe}',
    LUX_ONLY_WARNING: 'Warning !',
    LUX_ONLY_WARNING_TEXT: 'This store may also be badly mapped in CMS (Lux).',
    MAPPING: 'Mapping conflicts',
    MERCURY_ONLY: 'Mapping conflicts',
    MISSING_MAPPING: 'Missing mapping',
    MULTIPLE_LUX: 'Multiple stores in CMS (Lux)',
    MULTIPLE_MERCURY: 'Multiple stores in Mercury',
    OLD_TENANT: 'Old Tenant : %{oldTenant}',
    OPENING: 'Opening',
    OTHER: 'Other',
    RETAILER_MISSING: 'No retailer reference in CMS (Lux)',
    VACANT: 'Vacant',
    emptyUnit: '%{number} No store in CMS (Lux)',
    flagStore: 'If applicable, select one of the option below. Flag the store to indicate its stage :',
    gla: 'GLA : %{gla} m²',
    history: '%{state} by %{userName}',
    historyTitle: 'History',
    idMercury: 'id Store Mercury : %{idMercury}',
    jauge: 'This progress bar refers to the mapping of the stores sourced in Mercury. It is equal to the number of store rightly reconciled or mapped divided by the number of stores with a Mercury ID that are not closed. The whole multiplied by a hundred to have a percentage.',
    luxOnly: '%{number} No store in Mercury',
    manuallyFlagged: '%{number} Manually Flagged',
    manualyMapped: '%{number} Manually Mapped',
    mappingConflicts: '%{number} Mapping Conflicts',
    mappingImpossible: 'Mapping impossible',
    mappingStage: 'Mapping stage',
    multipleLux: '%{number} Multiple stores in CMS (Lux)',
    multipleMercury: '%{number} Multiple stores in Mercury',
    name: '%{mercuryName} (%{retailerName})',
    onlyInMercury: 'Stores only in Mercury :',
    openingDate: 'Opening date : %{openingDate}',
    otherStoreInformation: 'Other store informations',
    possibleMercury: 'Possible stores in Mercury not mapped yet',
    pourcentage: '%{pourcentage}%',
    retailerMissing: '%{number} No retailer reference in CMS (Lux)',
    sameRetailer: 'Possible Mercury stores from same retailer : ',
    sameRetailer_0: 'No possible Mercury stores found',
    storeInformation: 'Selected store Informations',
    title: 'MAPPING MODE',
    unMap: 'Unmap',
  },
  roi: {
    dealPerformanceTitle: 'Deal Performance - Main KPIs',
    subtitle: 'Here is an R.O.I. calculation tool. \n' +
      'An algorithm is used to randomly vary the KPI\'s between the defined bounds and determine the best results along different axes.',
    mgrfocus: 'MGR Focus',
    mgrfocus_details: 'Calculated by maximising the new MGR',
    incentivesfocus: 'Incentives Focus',
    incentivesfocus_details: 'Calculated by maximising the incentives',
    mgrfocusform: 'Custom Focus',
    mgrfocusform_details: 'Recalculate by modifying parameters',
    bpfocus: 'ROI BP %{bp}',
    bpfocus_details: 'Calculated with BP data',
    params: {
      title: 'KPIs Constraints',
      description: 'Bound parameters to enhance accuracy',
      exitCap: 'Exit cap',
      estimatedExitCap: 'Estimated exit cap',
      newMgr: 'New MGR',
      keyMoney: 'Key money',
      evictionCost: 'Eviction costs',
      foc: 'Works',
      leasingFeesOnUplift: 'Leasing fees on uplift',
      leasingFeesOnNewMgr: 'Leasing fees on new MGR',
      transferTaxAndTransactionCosts: 'Transfer tax & transaction costs',
      estimatedTransferTaxAndTransactionCosts: 'Estimated transfer tax & transaction costs',
      vacancy: 'Vacancy',
      rentFreePeriod: 'Rent free period',
      stepRentPercentage: 'Smoothed Step Rents',
      rentIncentives: 'Rent Incentives',
      tva: 'VAT',
      min: 'MIN',
      max: 'MAX',
      lossOfRent: 'Loss Of Rent',
      estimatedLossOfRent: 'Estimated loss of rent',
      vacancyCharges: 'Vacancy charges',
      estimatedVacancyCharges: 'Estimated vacancy charges',
      fra: 'FRA',
      pal: 'PAL',
    },
    category: {
      leasingFees: 'Leasing fees',
      estimatedLeasingFees: 'Estimated leasing fees',
      administration: 'Administration',
      incentives: 'Incentives',
      other: 'Other',
    },
    kpi: {
      title: 'KPIs OPERATION',
      mgr: 'MGR UPLIFT',
      newMgr: 'New MGR',
      oldMgr: 'Old MGR: %{amount}',
      tic: 'TIC (1)',
      roi: 'ROI',
      payback: 'Payback',
      keyMoney: 'Key Money',
      valueCreationVsCurrent: 'Value creation vs current',
      negativeUplift: 'Negative Uplift',
      negativeTic: 'TIC < 0',
      newMgrGlaNet: 'New MGR GLA Net',
      oldMgrGlaNet: 'Old MGR GLA Net',
    },
    compute: 'Compute',
    computing: 'Computing ROI ..',
    details: 'Details',
    pulse: 'Pulse',
    reset: 'Reset',
    toPercentage: 'To percentage',
    tooltip: {
      info: 'Locked parameters will not be modified',
      warning: 'Unlocked parameters that are not within KPIs Constraints will be set in constraints',
    },
  },
  bestDeals: {
    title: 'Best deal suggestions',
    subtitle: 'Based on the results of research firms, see if the selected proposal corresponds to the context of the shopping center.',
    weighted_spend: 'WEIGHTED SPEND',
    welldone: 'Well Done !',
    welldone_description: "There is a great potential in %{retailerName}'s target category",
    warning: 'Warning !',
    warning_description: "There is few potential in %{retailerName}'s target category. You should focus on \"%{branchLevelName}\".",
    other_sc_suggested: 'Other top level suggested :',
    branch_expectation: 'Top level turnover (Mercury %{year})',
    country_average: 'Country average',
    country_average_mercury: 'Country average (Mercury)',
    country_average_caci: 'Country average (Caci)',
    catchment_expectation: 'Catchment expectation (Caci %{year})',
    selected_label_information: '(Selected)',
    report: 'Download Data',
    report_filename: 'Weighted_Spend_%{scName}.xlsx',
    no_data: 'NO DATA',
  },
  clusters: {
    title: 'Clusters',
    subtitle: 'See the compatibility across the other retailers of your shopping centre.',
    tlp: {
      title: 'Cross sell in any BL',
      title_same_bl1: 'Cross sell in the same BL - %{currentBL}',
      subtitle: 'Through the Transaction Loyalty Program here are the brands that are consumed at the same time as %{currentRetailer}. This is the percentage of people that have bought at %{currentRetailer} and at an other retailer',
      subtitle_same_bl1: 'Through the Transaction Loyalty Program here are the brands from the same branch level that are consumed at the same time as %{currentRetailer}. This is the percentage of people that have bought at %{currentRetailer} and at an other retailer',
      legend: 'Brands that are present in the shopping center',
      see_more: 'See More',
      no_clusters: 'No clusters found',
    },
  },
  goodwill: {
    title: 'Goodwill',
    subtitle: 'The Goodwill would be the maximum amount we would agree to grant to a powerful brand in deviation with its current ERV to attract or sustain its presence in consideration of its positive impact over a shopping center in terms of total sales & footfall.',
    gerv: {
      title: 'GERV',
      description: 'ERV N minus rent goodwill reachable',
    },
    rentGoodwillReachable: {
      title: 'Rent Goodwill reachable',
      description: 'Max 15% over MGR',
    },
    attractiveScore: {
      title: 'Attractive score',
      description: 'The "power" of a brand on the market within a regional scope',
    },
    score: '%{score}/10',
    impact: {
      title: 'IMPACT OVER STORES',
      proximity: {
        title: 'Proximity ratio',
        description: '10% of sales for stores < 50 m',
      },
      systematic: {
        title: 'Systematic ratio',
        description: '1% of sales when attractive score > 8',
      },
      synergic: {
        title: 'Synergic ratio',
        description: '5% of sales for BL3 impacted',
      },
      total: {
        title: 'Total ratio',
        description: 'Sum of proximity, systematic and synergic ratios',
      },
      reachable: {
        title: 'Total Goodwill after ceiling',
        description: 'Max 10% of MGR or % impact over MGR instead',
      },
      storeNumber: '(%{number} stores)',
      mgrPercentage: '(%{percentage} total MGR)',
    },
    tooltip: {
      proximity: {
        title: 'Proximity impact: %{ratioValue}',
        top5OtherLocomotives: 'Proximity impacts Top 5\n other locomotives',
        average: 'Average: %{ratioValue}',
        sum: 'Sum: %{ratioValue}',
      },
      synergic: {
        title: 'Synergic impact: %{ratioValue}',
        bl3BranchName: 'BL3 name: %{bl3Name}',
        impactedLocomotives: 'Impacted locomotives:',
      },
      systematic: {
        title: 'Systematic impact: %{ratioValue}',
        impactedLocomotives: 'Impacted locomotives:',
      },
      total: {
        title: 'Total impact: %{ratioValue}',
        top5OtherLocomotives: 'Total impacts Top 5\n other locomotives',
        average: 'Average: %{ratioValue}',
        sum: 'Sum: %{ratioValue}',
      },
      locomotive: {
        title: 'Locomotive',
        proximity: 'Proximity impact: %{ratioValue}',
        synergic: 'Synergic impact: %{ratioValue}',
        systematic: 'Systematic impact: %{ratioValue}',
        total: 'Total impact: %{ratioValue}',
        totalGoodwillReachableAfterCeiling: 'Total goodwill reachable \nafter ceiling impact: %{ratioValue}',
      },
    },
    legend: {
      selected: 'Store selected',
      NA: 'Stores N/A',
      locomotive: 'Locomotives',
    },
    report: 'Download excel',
  },
  attractiveScore: {
    title: 'Attractive score',
    store_score: '%{storeName}\'s attractive score',
    score: '%{score}/10',
    scoreParenthesis: '(%{score}/10)',
    subtitle: 'The Attractive Score is a in-depth study to access the "power" of a brand on the market within a regional scope',
    explanation: 'It is based on 3 dimensions that would access what is making it valuable for an asset at a certain date, following a mix of quantitative an qualitative criteria. Please note that the scoring is based on available data to date and subject to various improvements.',
    no_data: 'NO DATA',
    scarcity: {
      title: 'Scarcity',
      subtitle: 'The scarcity of the physical sales points over a region.',
      explanation: 'We consider that over a certain level of revenues, the scarcity of sales points makes each one more attractive for customers.',
      penetration: 'Penetration rate in URW French assets',
      people: '# of millions people in France per store',
      turnover: 'Annual brand turnover of stores (in m€)',
    },
    differentiation: {
      title: 'Differentiation',
      subtitle: 'The differentiation of products and stores.',
      explanation: 'We consider that a part of attractiveness is due to the uniqueness of products and concept designs. This measurement is purely qualitative.',
      product: 'Product Uniqueness',
      store: 'Store Uniqueness',
      details: {
        button: 'Details',
        title: 'Differentiation of products and stores',
        rules: {
          title: 'Rule %{ruleNumber}:',
          rule1: 'Score rating must be appreciated through the same BL3 competitors market.',
          rule2: 'The market leader should benefit from better grades than its competitors.',
          rule3: 'Direct distributor of products should benefit from better grade than indirect distributors, except when the shop concept is different from other indirect distributors or when they provide a well though-out of products.',
          rule4: 'When a brand does not stand out for a particular criterion, the score should be between 5 and 6.5. Scores below 5 should act as a sanction when it appears that some criticism can be made of the brand.',
          rule5: 'Unique initiatives from brands should be rewarded in the grades, even if it do not apply to all stores.',
        },
        product: {
          title: 'Product uniqueness',
          question1: {
            question: '1. Is the core product(s) offered by the brand rare to find in outlets ?',
            lowScore: 'No, easily findable in many outlets',
            highScore: 'Yes, very rare with few exclusive distribution points',
          },
          question2: {
            question: '2. Does the brand core product(s) has intrinsic characteristics that distinguishes it sufficiently from similar products over the same market ?',
            lowScore: 'No, very common and easily substitutable',
            highScore: 'Yes, inimitable footprint',
          },
          question3: {
            question: '3. Does the brand tend to renew its range of products oftenly ?',
            lowScore: 'No, constancy of product(s) over the years',
            highScore: 'Yes, new range of products are frequently available',
          },
          question4: {
            question: '4. Does the customer base of the brand is very engaged in core product(s) ?',
            lowScore: 'No, customers buy the product(s) only for convenience',
            highScore: 'Yes, outstanding devotion to the product(s)',
          },
        },
        store: {
          title: 'Store uniqueness',
          question1: {
            question: '1. Does the outlet offer a sufficiently unique physical design that make it easily recognizable ?',
            lowScore: 'No, common design',
            highScore: 'Yes, most people can say what brand it is uniquely by looking at the storefront',
          },
          question2: {
            question: '2. Does the brand tend to offer unique customer experiences within its outlets?',
            lowScore: 'No, classic shops easily reproducible',
            highScore: 'Yes, the brand develops and renews state-of-art concepts within the shops',
          },
          question3: {
            question: '3. Does the shop sellers are recognized for the uniqueness of their customer relations?',
            lowScore: 'No, sellers do the minimum ',
            highScore: 'Yes, sellers have a unique sense of dealing with customers',
          },
          question4: {
            question: '4. Does the marketing methods used to promote the core product(s) within the outlets are innovative ?',
            lowScore: 'No, product promotions do not exist',
            highScore: 'Yes, product promotions are very unique',
          },
        },
      },
    },
    trendiness: {
      title: 'Trendiness',
      subtitle: 'The trendiness of the brand from a customer perspective.',
      explanation: 'Proxies are used to evaluate the subjective trendiness of a brand on a annual basis(annual growth of revenues and organic web search over a scope of top 5 competitors in a regional market).',
      growth: 'Group revenue growth %{year}',
      awareness: 'Brand awareness',
    },
  },
  MKT_PAGE: {
    banner_message: 'Datas are outdated for the following providers : MyFeelBack and Transaction Loyalty Program. We are actively working to fix it.',
    NO_DATA_CACI: 'No CACI data for this country and for this mall.',
    NO_TABLEAU_VIEWS: 'No tableau views available for this country',
    center_trade_area: {
      title: 'Catchment area',
      tooltip: 'Each postcode within the catchment is ranked by weighted spend potential from high to low. The postcodes that contain the first 50% of weighted spend potential make up the Primary Trade Area. The next 25% are the Secondary, the next 15% the Tertiary and the final 10% the Beyond. CACI 2022',
      centre_trade_area_tab: {
        total_population: 'Total Population',
        total_retail_spend: 'Total Retail Spend (M€)',
        total_retail_spend_potential: 'Total Weighted Retail Spend Potential (M€)',
        market_share: 'Market Share',
      },
      NO_DATA: 'No Catchment area map for this mall',
      NO_DATA_ACTIONS: 'The marketing manager didn\'t filled the necessary information.',
    },
    key_figures: {
      title: 'Key figures',
      tooltip: {
        title: 'Key figures',
        dwell_time: 'Dwell time',
        dwell_time_content: 'Average time spent in minutes by loyal visitors on the shopping center during their visit.\nData overridden manually',
        total_population: 'Total population:',
        total_population_content: 'Total population within the Catchment Area including Beyond area.\nCACI 2022',
        average_spend_basket: 'Average spend basket:',
        average_spend_basket_content: 'Average amount spent in your shopping centre.\nURW customer survey, Data overridden manually',
        total_weighed_sp: 'Total weighted spend potential:',
        total_weighed_sp_content: 'Share of the total retail spend within the Trade Area that has the potential to be spent at the centre once the attractiveness of the centre, the competition and accessibility are taken into account.\nCACI 2022',
        loyalty_cards: 'Loyalty cards:',
        loyalty_cards_content: 'No of loyalty cards delivered by the shopping centre.\nOngoing number.',
        website_unique_visitors: 'Websites unique visitors:',
        website_unique_visitors_content: 'No of visitors who comes one or multiple times during the day on your shopping centre website and still count as one visitor.\nSince website opened.',
        app_downloaded: 'App downloaded:',
        app_downloaded_content: 'No of visitors who uploaded your shopping centre application.\nSince app delivery.',
      },
      totalPopulation: 'Total population',
      spendBasket: 'Average spend basket',
      weighedSpendPotential: 'Total weighted spend potential',
      loyaltyCard: 'Loyalty cards',
      websiteUniqueVisitors: 'Website unique visitors',
      appDownloaded: 'App downloaded',
      NO_DATA: 'No key figures data found for this shopping centre.',
    },
    weighted_spend_potential: {
      title: 'Weighted Spend Potential',
      tooltip: 'Share of the Total Retail Spend within the Catchment Area that has the potential to be spent at the centre taking the attractiveness of the centre, the competition and accessibility into account.\nCACI 2022',
      tooltips_graph: {
        weighted_spend: 'Weighted Spend potential',
        country_average: 'Average Country Weighted Spend',
      },
      legend: {
        branch_expectation: 'CACI Top level category',
        country_average: 'Country average',
      },
    },
    penetration_rate: {
      title: 'Penetration Rate',
      tooltip: 'No of unique visitors of the shopping centre divided by the total population of the zone selected.\nOrange up-to-date',
    },
    dominantCustomer: {
      title: 'Dominant Customer profiles',
      tooltip: 'The most represented consumer groups in the catchment area (using the Acorn classification).\nCACI %{year}',
      tooltipNoData: 'The most represented consumer groups in the catchment area (using the Acorn classification).\nNo CACI data for this country and for this mall.',
      HOUSEHOLD_SIZE: 'HOUSEHOLD SIZE',
      AVERAGE_AGE: 'AVERAGE AGE',
      HOME_OWNERSHIP: 'HOME OWNERSHIP',
      LIKELIHOOD_TO_MOVE: 'LIKELIHOOD TO MOVE',
      CHILDREN_AT_HOME: 'CHILDREN AT HOME',
      AVERAGE_INCOME: 'AVERAGE INCOME',
      SHOPPING_CENTER_COVERAGE: '% OF SHOPPING CENTER',
    },
    customer_profile: {
      title: '% Dominant Customer profiles (Acorn Profiles)',
      group_name: '%{percentage} %{categoryName} groups',
      tooltip: 'A segmentation of your catchment area population where the groups/profiles are defined with demographics and lifestyles information.\nCACI %{year}',
      tooltipNoData: 'A segmentation of your catchment area population where the groups/profiles are defined with demographics and lifestyles information.\nNo CACI data for this country and for this mall.',
      tooltips_graph: {
        app_data_profile: 'Population Percentage',
        total_app_data_profile: 'Total Category Population Percentage',
        country_average: 'Average Country Population Percentage',
      },
      legend: {
        app_data_profile: 'Acorn profiles',
        country_average: 'Country average',
      },
    },
    monthly_survey: {
      title: 'Monthly Loyalty Survey',
      tooltip: 'URW customer survey sent every month to the loyalty customer database. \nMyFeelBack 2019',
      NO_DATA: 'No survey data found for this shopping centre.',
      nb_response: 'N° of responses : %{number}',
      spending_basket: {
        title_line_1: 'Averages spending basket',
        title_line_2: 'by categories',
        stores: 'STORES',
        leisure: 'LEISURE',
        services: 'SERVICES',
        hypermarket: 'HYPERMARKET',
        restaurants_line_1: 'RESTAURANTS',
        restaurants_line_2: '& CAFES',
      },
      store_visited: {
        title_line_1: 'Stores visited & ',
        title_line_2: 'spent in',
        with_without_purchase_line_1: 'stores visited with',
        with_without_purchase_line_2: '& without purchase',
        with_purchase_line_1: 'stores visited with',
        with_purchase_line_2: 'purchase',
      },
    },
  },
};

export default en;
